import { SuccessIcon } from '../../Templates/PairingTemplate/PairingTemplate.styled';
import {
    Body,
    StyledRegistrationHeadingSection,
    Title,
} from './RegistrationHeadingSection.styled';

/* ---------------------------------- Types --------------------------------- */

/**
 * DumbRegistrationHeadingSectionI
 */
export interface DumbRegistrationHeadingSectionI {
    /** Title to display, fed from the dictionary */
    title?: string;

    /** Subtitle to display, fed from the dictionary */
    subtitle?: string;

    /** Body to display, fed from the dictionary */
    body?: string;

    icon?: string;
}

/* -------------------------------- Component ------------------------------- */

/**
 * DumbRegistrationHeadingSection
 *
 * Renders a display containing a title and descriptions of a form, normally
 * in the registration template
 *
 * @param props DumbRegistrationHeadingSectionI
 * @returns JSX.Element
 */
const DumbRegistrationHeadingSection = ({
    body,
    icon,
    subtitle,
    title,
}: DumbRegistrationHeadingSectionI) => (
    <StyledRegistrationHeadingSection>
        {title && title.trim() !== '' && <Title>{title}</Title>}
        {icon && <SuccessIcon className={`fa ${icon}`} />}
        {subtitle && subtitle.trim() !== '' && <Body>{subtitle}</Body>}
        {body && body.trim() !== '' && <Body>{body}</Body>}
    </StyledRegistrationHeadingSection>
);

/* --------------------------------- Export --------------------------------- */

export default DumbRegistrationHeadingSection;
